import state from './state'

export default {
    getUser:    () => state.user || [],
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    verified:   () => state.verified || false,
}